(function() {
  'use strict';

  angular.module('component.events')
    .component('eventViewComponent', {
      controller: 'EventViewController',
      controllerAs: 'eventViewCtrl',
      templateUrl: 'app/components/events/view.html',
      bindings: {
        eventId: '<',
        eventObj: '<',
        user: '<',
        tearoff: '<',
        scrollTo: '<',
        token: '<'
      }
    })
    .component('tearoffEventViewComponent', {
      controller: 'EventViewController',
      controllerAs: 'eventViewCtrl',
      templateUrl: 'app/components/events/tearoff.html',
      bindings: {
        eventId: '<',
        eventObj: '<',
        user: '<',
        tearoff: '<',
        scrollTo: '<',
        token: '<',
        action: '<'
      }
    });
})();

